import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import AccCoverSelecter from "./AccCoverSelecter";
import {Server, ProductsListsContext, ModalHelper, AlertModal, helper}  from "../app.js"; 

export default class AccessorySelecter extends PureComponent 
{
    static contextType = ProductsListsContext;
    real_quantity = 0;  
    modal = null;      
    
    constructor (props)
    {
        super(props);

        const hasAccessory = !helper.isNotObjectOrEmpty(this.props.init_accessory);

        this.state = {
            accessories: {},
            id: hasAccessory ? this.props.init_accessory.id : '',            
            quantity: hasAccessory ? this.init_accessory.quantity : 0,
            length: hasAccessory ? this.init_accessory.length : 0,
            loading: false,
            alert_message: ''
        };

        if (hasAccessory && this.init_accessory?.quantity_multiple > 1)
        {
            this.state.quantity /= this.init_accessory.quantity_multiple;
        }
        this.real_quantity = this.state.quantity;

        this.modal = new ModalHelper(this);
        
        this.selectAccessory = this.selectAccessory.bind(this);   
        this.selectCover = this.selectCover.bind(this);   
        this.setQuantity = this.setQuantity.bind(this);
        this.roundQuantity = this.roundQuantity.bind(this);
        this.setLength = this.setLength.bind(this);
        this.checkLength = this.checkLength.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    get accessory ()
    {
        const id = this.state.id;
        let accessory = null;

        if (id && id in this.state.accessories)
        {
            accessory = this.state.accessories[id];
        }
        return accessory;
    }
    isActive ()
    {
        return this.props.tray_articul && this.props.type;
    }
    loadAccessories ()
    {
        if (this.isActive())    
        {
            const queryParams = {acc_type: this.props.type, tray_articul: this.props.tray_articul};

            this.setState({loading: true});
            this.real_quantity = 0;

            Server.instance
                .query('get_accessories', queryParams)
                .then((recievedAccessories) =>
                {
                    //console.log(recievedAccessories);
                    helper.setStateWithRecievedItems(this, 'accessories', recievedAccessories, function (fields, product)
                    {
                        ({
                            cover: product.cover_id = '',
                            multiple : product.quantity_multiple = 1,
                            countMultiLimit: product.quantity_limit = false, // сейчас не используется
                            removingTrayConn: product.remove_conn_cnt = 0 // сейчас не используется
                        } = fields);

                        ['quantity_multiple', 'quantity_limit', 'remove_conn_cnt'].forEach(field => 
                        {
                            product[field] = helper.toNumber(product[field]);
                        });

                        product.quantity_multiple = parseInt(product.quantity_multiple);
                        if (!product.quantity_multiple) product.quantity_multiple = 1;
                    });
                })
                .catch(() => this.setState({accessories: {}, loading: false}));
        }        
    }
    selectAccessory (e)
    {
        const id = e.target.value,
            newAcc = id ? helper.copyObject(this.state.accessories[id]) : null;

        this.setState({id, quantity: 0});
        /*
        this.setState({id, quantity: 1});

        if (newAcc && this.useLengthFor(id))
        {
            this.setState({length: newAcc.length});
        }*/

        this.props.on_select(!helper.isNotObjectOrEmpty(newAcc) ? newAcc : null, 'accessory');
    }
    selectCover (cover)
    {
        if (!helper.isNotObjectOrEmpty(this.accessory))
        {
            const quantityMultiple = this.accessory.quantity_multiple;

            if (cover && quantityMultiple)
            {
                cover.quantity *= quantityMultiple;
            }
            this.props.on_select(cover, 'cover', false);
        }
    }
    setQuantity (e)
    {
        const accessory = helper.copyObject(this.accessory);

        if (!helper.isNotObjectOrEmpty(accessory) && !this.useLength())
        {
            let quantity = e.target.value;
            //const quantityMultiple = accessory.quantity_multiple;
            
            if ('' !== quantity)
            {
                quantity = parseInt(quantity);

                if (isNaN(quantity) || quantity < 0)
                {
                    this.setState({alert_message: 'Некорректное значение количества аксессуаров'});
                }
                else if (!quantity)
                {
                    this.setState({alert_message: 'Не задано количество аксессуаров'});
                }
                else
                {
                    this.setState({quantity});
                    
                    this.real_quantity = quantity;

                    accessory.quantity = quantity * accessory.quantity_multiple;
                    this.props.on_select(accessory, 'accessory');
                }
            }
            else
                this.setState({quantity});
        }
    }
    roundQuantity ()
    {
        if (this.accessory && this.real_quantity)
        {
            this.setState({quantity: this.real_quantity}); 
        }
    }
    setLength (e)
    {
        const accessory = helper.copyObject(this.accessory);

        if (accessory && this.useLength())
        {
            const accLength = accessory.length,
                lengthValue = e.target.value.trim();

                if ('' !== lengthValue)
                {
                    if (/^\d+\.?\d*$/.test(lengthValue))
                    {
                        if ('.' != lengthValue.slice(-1))
                        {
                            const length = parseFloat(lengthValue);

                            this.setState({length});

                            if (0 == length)
                            {
                                this.setState({length: '0'});
                            }
                            else if (length >= 0.01)
                            {
                                const quantity = Math.ceil(length * 1000 / accLength);

                                this.setState({quantity});

                                this.real_quantity = quantity;

                                accessory.quantity = quantity * accessory.quantity_multiple;
                                this.props.on_select(accessory, 'accessory');
                            }
                            //else
                            //    this.setState({alert_message: `Не задана длина аксессуара`});                        
                        }
                        else
                            this.setState({length: lengthValue});
                    }
                    else
                        this.setState({alert_message: 'Некорректное значение длины аксессуара'});
                }
                else
                    this.setState({length: ''});
        }
    }
    checkLength (e)
    {
        const accessory = helper.copyObject(this.accessory);

        if (accessory && this.useLength() && e.target.value < 0.01)
        {
            const length = '',
                quantity = 0;

            this.setState({length, quantity});
            //, alert_message: 'Значение длины аксессуара не может быть меньше 100мм'

            accessory.quantity = quantity;
            this.props.on_select(accessory, 'accessory');
        }
    }
    useLength () 
    {
        return this.useLengthFor(this.accessory?.id);
    }
    useLengthFor (id)
    {
        //console.log('useLengthFor', id);

        return  id 
                && id in this.state.accessories
                && helper.isMeterProduct(this.state.accessories[id]);
    }
    componentDidMount() 
    {
        this.loadAccessories();
    }
    render() 
    {
        const accessory = this.accessory,
            hasAccessory = !helper.isNotObjectOrEmpty(accessory),            
            accCoverId = hasAccessory ? accessory.cover_id : '',
            quantity = this.state.quantity ? this.state.quantity : '',
            useLength = this.useLength(),
            canInputLength = this.isActive() && hasAccessory && useLength,
            canInputQuantity = this.isActive() && hasAccessory && !useLength,
            accessoriesList = Object.keys(this.state.accessories).map(id => 
                {
                    return <option key={id} value={id}>{'articul' == this.context ? this.state.accessories[id].articul : this.state.accessories[id].name}</option>;
                });
        accessoriesList.unshift(<option key="none" value="">Аксессуар не выбран</option>);

        return (<>
            <Form.Row className="accessory-selecter">
                <Form.Group as={Col} lg={7}>
                    <Form.Label className={!this.isActive() ? 'text-muted' : ''}>Совместимые аксессуары:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectAccessory} onClick={this.modal.showProjectChangeWarning} value={this.state.id} disabled={!this.isActive()} as="select" htmlSize={6} custom>
                        {accessoriesList}
                    </Form.Control>
                </Form.Group>

                <Col lg={5}>
                    {!useLength
                    ? <Form.Group className="accessory-selecter__qauntity">
                            <Form.Label className={!canInputQuantity ? 'text-muted' : ''}>Кол-во аксессуаров</Form.Label>
                            <Form.Control onChange={this.setQuantity} onBlur={this.roundQuantity} onClick={this.modal.showProjectChangeWarning} value={quantity} disabled={!canInputQuantity} type="text" className="mb-2" placeholder="Кол-во аксессуаров" />
                        </Form.Group>
                    : <Form.Row>
                            <Form.Group as={Col} sm={6}>
                                <Form.Label className={!canInputLength ? 'text-muted' : ''}>Длина,&nbsp;м:</Form.Label>
                                <Form.Control onChange={this.setLength} onBlur={this.checkLength} onClick={this.modal.showProjectChangeWarning} value={this.state.length} disabled={!canInputLength} type="text" className="mb-2" placeholder="Длина аксессуара, м" />
                            </Form.Group>

                            <Form.Group as={Col} sm={6}>
                                <Form.Label className={!canInputQuantity ? 'text-muted' : ''}>Кол-во,&nbsp;шт:</Form.Label>
                                <Form.Control value={quantity} disabled={!canInputQuantity} type="text" className="mb-2" placeholder="Кол-во аксессуаров, шт" />
                            </Form.Group>
                        </Form.Row>
                    }
                    <AccCoverSelecter key={`acs_${accCoverId}`} on_select={this.selectCover} acc_cover_id={accCoverId} acc_quantity={quantity} />
                </Col>
            </Form.Row>
            <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} />
        </>);
    }
}
